import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Box, Paper } from '@material-ui/core'
import { useStyles } from './style'
import { TableOutline } from '../../elements'
import { eventStatus, EVENT_TYPE, getEventsTableHeadings, ONGOING } from './constant'
import { dashboardService } from '../../Services/Dashboard/Dashboard'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import * as messageTypes from '../../utils/messageTypes'
import { ComponentLoader, DisplayMessage, Loader } from '../../Components'
import { usePrevious } from '../../Components/CustomHooks'
import moment from 'moment'
import RefreshIcon from '@material-ui/icons/Refresh'
import { timeZoneAbbrs } from '../../utils/momentTimezones'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function UpcomingEvents(props) {
  const classes = useStyles()
  const [events, setEvents] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [tableData, setTableData] = useState([])
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const history = useHistory()
  const { currentUser, account } = props
  const prevAccount = usePrevious(props.account)

  const getEvents = () => {
    setLoading(true)
    dashboardService.getOngoingEvents(currentUser, props.account, page - 1, rowsPerPage, props.timeZone)
      .then(eventsData => {
        setLoading(false)
        setEvents(eventsData.events)
        setEventsTable(eventsData.events)
        setTotalCount(eventsData.total_count)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const setEventsTable = (eventsData) => {
    let eventsTable = []
    eventsData.map((obj, index) => {
      let tableObj = [
        {
          id: 'sno',
          value: ((page - 1) * rowsPerPage) + (index + 1)
        },
        {
          id: 'program_name',
          value: obj.program_name,
          handleClick: () => { history.push(`/programs/${obj.program_id}`) }
        },
        {
          id: 'event_name',
          value: obj.event_name,
          handleClick: () => { history.push(`/programs/${obj.program_id}/events/${obj.event_id}`) }
        },
        {
          id: 'event_type',
          value: _.get(obj, 'event_type', '') ? EVENT_TYPE[obj.event_type] || '' : '-',
        },
        {
          id: 'event_start_time',
          value: moment(obj.event_start_time).tz(props.timeZone).format('MMMM DD, YYYY hh:mm A zz')
        },
        {
          id: 'event_end_time',
          value: moment(obj.event_end_time).tz(props.timeZone).format('MMMM DD, YYYY hh:mm A zz')
        },
        {
          id: 'event_duration',
          value: obj.event_duration
        },
        {
          id: 'event_status',
          value: obj.event_status ? eventStatus[obj.event_status] : '-'
        }
      ]
      eventsTable.push(tableObj)
    })
    setTableData(eventsTable)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const resetPage = () => {
    setPage(1)
    setRowsPerPage(10)
  }

  useEffect(() => {
    if (prevAccount !== props.account) {
      resetPage()
    }
    if (props.account) {
      getEvents()
    }
  }, [props.account, page, rowsPerPage])

  return (
    <Box p={2}>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => { setOpen(false) }} />
      <Box className={classes.summaryheaderWrapper} display="flex">
        <Box flexGrow={1}>Ongoing And Upcoming Events</Box>
        <Box ><RefreshIcon className={classes.refreshIcon} onClick={getEvents} /></Box>
      </Box>
      {loading ? <ComponentLoader loading={loading} style={{ height: 200 }} /> :
        <Box className={`${classes.cardWrapper}`} mt={2}>
          <TableOutline
            tableHeadings={getEventsTableHeadings(ONGOING)}
            tableData={tableData}
            totalElement={totalCount}
            loading={loading}
            pagination={tableData.length > 0}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage} />
        </Box>
      }
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, timeZone } = auth
  return { currentUser, isSuperAdmin, timeZone }
}

export default connect(mapStateToProps, {})(UpcomingEvents)